module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/three-dots-ellipsis-4adf337cb0e50a9cb68abd00e7cae6c0.svg";